// Pure, frontend-only plan. Default working covers are presentational, never saved assets.
export function novelBookCoverConfirmationPlanV1({
  frontFile = null, backFile = null, replaceFront = false, replaceBack = false,
} = {}) {
  const front = Boolean(frontFile);
  const back = Boolean(backFile);
  return {
    required: front || back,
    front, back,
    replaceFront: front && replaceFront === true,
    replaceBack: back && replaceBack === true,
    frontFile: front ? frontFile : null,
    backFile: back ? backFile : null,
  };
}

export function novelBookCoverConfirmationCopyV1(plan = {}, isFR = false) {
  const safePlan = plan && typeof plan === "object" && !Array.isArray(plan) ? plan : {};
  const replacesSaved = Boolean(safePlan.replaceFront || safePlan.replaceBack);
  const title = isFR
    ? (replacesSaved ? "Confirmer le remplacement des couvertures ?" : "Utiliser les couvertures sélectionnées ?")
    : (replacesSaved ? "Confirm cover replacement?" : "Use the selected cover artwork?");
  const parts = [];
  if (safePlan.front) parts.push(isFR
    ? (safePlan.replaceFront ? "la couverture avant enregistrée" : "le modèle provisoire de couverture avant")
    : (safePlan.replaceFront ? "your saved front cover" : "the temporary default front-cover design"));
  if (safePlan.back) parts.push(isFR
    ? (safePlan.replaceBack ? "la couverture arrière enregistrée" : "le modèle provisoire de couverture arrière")
    : (safePlan.replaceBack ? "your saved back cover" : "the temporary default back-cover design"));
  const message = isFR
    ? `Enregistrer Book Setup remplacera ${parts.join(" et ")} par les images sélectionnées. Les modèles provisoires ne sont pas enregistrés. Les PDF approuvés ne seront pas modifiés.`
    : `Saving Book Setup will replace ${parts.join(" and ")} with the selected image${safePlan.front && safePlan.back ? "s" : ""}. Default designs are only previews. Previously approved PDFs will remain unchanged.`;
  return { title, message };
}
